__turbopack_context__.v({
  "article": "D9JjRq_article",
  "author": "D9JjRq_author",
  "buttonInner": "D9JjRq_buttonInner",
  "buttonMain": "D9JjRq_buttonMain",
  "container": "D9JjRq_container",
  "date": "D9JjRq_date",
  "divider": "D9JjRq_divider",
  "forceClose": "D9JjRq_forceClose",
  "iconCaret": "D9JjRq_iconCaret",
  "iconImage": "D9JjRq_iconImage",
  "iconWrap": "D9JjRq_iconWrap",
  "itemDropdown": "D9JjRq_itemDropdown",
  "itemInner": "D9JjRq_itemInner",
  "itemMain": "D9JjRq_itemMain",
  "menuDropdown": "D9JjRq_menuDropdown",
  "menuInner": "D9JjRq_menuInner",
  "menuMain": "D9JjRq_menuMain",
  "set": "D9JjRq_set",
  "size--sm": "D9JjRq_size--sm",
  "size--xs": "D9JjRq_size--xs",
});
